module.exports = __webpack_public_path__ + "img/Intro.f2661d8e.jpg";